module.exports = __webpack_public_path__ + "img/Number=15.79394e6d.png";